const ChoosingCareerChallenge1HintsText =
    ["Try to match the job skills that are listed at the top of each column " +
        "with the abilities that are described for each person.",
     "Nancy's abilities sound like she would not enjoy a job as an elementary school teacher.",
     "Tom's skillset sounds like a good fit for a Registered Nurse.",
     "Max probably would not enjoy working as an elementary school teacher."]
 
export default ChoosingCareerChallenge1HintsText;